<div class="container-main">
  <div class="container">
    <div class="row">
      <div class="col-12 form-group">
        <p class="title-contact">Encuéntrame en</p>
      </div>
      <div class="col-12 form-group">
        <a class="button-social" href="https://www.udemy.com/user/alain-nicolas-tello/" target="_blank"><img class="image-medium" src="../../../assets/logo_udemy.png" alt=""> Udemy</a>
      </div>
      <div class="col-12 form-group">
        <a class="button-social" href="https://www.facebook.com/cursosAndroidAnt" target="_blank"><i class="fa fa-facebook-square" aria-hidden="true"></i> Facebook</a>
      </div>
      <div class="col-12 form-group">
        <a class="button-social" href="https://twitter.com/alain_nt" target="_blank"><i class="fa fa-twitter-square" aria-hidden="true"></i> Twitter</a>
      </div>
      <div class="col-12 form-group">
        <a class="button-social" href="https://www.youtube.com/channel/UC9Cxb3wO3GmsVn0j8KFS7Ww" target="_blank"><i class="fa fa-youtube-play" aria-hidden="true"></i> YouTube</a>
      </div>
      <div class="col-12 form-group">
        <a class="button-social" href="https://www.linkedin.com/in/alain-nicol%C3%A1s-tello-aa4a25bb/" target="_blank"><i class="fa fa-linkedin-square" aria-hidden="true"></i> Linkedin</a>
      </div>
      <div class="col-12 form-group">
        <a class="button-social" href="https://alainnicolastello.medium.com" target="_blank"><img class="image-medium" src="../../../assets/medium.jpeg" alt=""> Medium</a>
      </div>
    </div>
  </div>
</div>
<div class="container-footer">
  <div class="container">
    <div class="row">
      <div class="col-12 form-group">
        <img class="image-footer" src="../../../assets/android.png" alt="">
      </div>
    </div>
  </div>
</div>